import { FiHeart, FiMail, FiUsers } from 'react-icons/fi'
import { ROUTES } from '@/constants/routes'
import type { CtaLink } from '@/types/cta'

export const ctas: CtaLink[] = [
  {
    to: ROUTES.PARTNER,
    label: 'Become a Partner',
    description: 'Collaborate with us on programmes across Africa and the Caribbean.',
    Icon: FiUsers,
  },
  {
    to: ROUTES.DONATE,
    label: 'Donate Now',
    description: 'Support young entrepreneurs, students, and vulnerable communities.',
    Icon: FiHeart,
  },
  {
    to: ROUTES.CONTACT,
    label: 'Contact Us',
    description: 'Reach our team for partnerships, media, or general enquiries.',
    Icon: FiMail,
  },
]
